/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-chevron-right': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M13.75 10L7.5 16.25l-.875-.875L12 10 6.625 4.625 7.5 3.75z" _fill="#000" fill-rule="evenodd"/>'
  }
})
